<div class="header">
  <div class="header-cont modals">
    <h2 mat-dialog-title>{{ 'admin_single_itin.dialog.title_video' | translate }}</h2>
    <mat-icon>videocam</mat-icon>
  </div>
</div>

<mat-form-field class="section-input">
  <mat-label>{{ 'admin_single_itin.dialog.url_video' | translate }}</mat-label>
  <input matInput type="text" required [(ngModel)]="videoUrl" (keyup)="checkUrlPattern()">
</mat-form-field>

<div *ngIf="wrongUrl && !!videoUrl" class="wrong-att">
  <p>{{ 'attachment.wrong_pattern' | translate }}</p>
</div>

<mat-dialog-actions align="center" class="dialog-btns">
  <button mat-button [mat-dialog-close]="false" (click)="onNoClick()">{{ 'admin_single_itin.dialog.cancel' | translate }}</button>
  <button mat-button [mat-dialog-close]="newFile()" [disabled]="wrongUrl" cdkFocusInitial class="dialog-confirm">{{ 'admin_single_itin.dialog.ok' | translate }}</button>
</mat-dialog-actions>
